/**
 * @type {string}
 */
export const CLASS_LOADED = '-is-loaded';
export const CLASS_ANIMATING_IN = '-animating-in';
export const CLASS_ANIMATED_IN = '-is-visible';
export const CLASS_IS_HIDDEN = '-is-hidden';

/**
 * @type {string}
 */
export const ID_WEBSITE = 'website';

/**
 * Dit is de marge waarmee wordt berekend of de strook in beeld is of niet.
 *
 * @type {number}
 */
export const SCROLL_MARGIN = 200;

export class Controller {

  /**
   * Controller constructor
   *
   * @param {HTMLElement} element
   */
  constructor(element) {

    /**
     * @type {HTMLElement}
     * @private
     */
    this._element = element;

    /**
     * @type {boolean}
     */
    this.loaded = false;

    /**
     * @type {HTMLElement[]}
     * @private
     */
    this._viewportElements = [];

    /**
     * @type {null|HTMLElement}
     * @private
     */
    this._conversion = null;

    /**
     * @type {null|HTMLElement}
     * @private
     */
    this._footer = null;

  }

  /**
   * Zet het element in de `is loaded` status.
   */
  setLoadedState() {
    this.loaded = true;
    this._element.classList.add(CLASS_LOADED);
  }

  /**
   * Zorgt voor het in-animeren van een object.
   *
   * @param {HTMLElement} element
   * @param {number} time
   */
  animateIn(element, time) {
    element.classList.add(CLASS_ANIMATING_IN);

    setTimeout(() => {
      element.classList.remove(CLASS_ANIMATING_IN);
      element.classList.add(CLASS_ANIMATED_IN);
    }, time);
  }

  /**
   * @param {HTMLElement} element
   */
  addViewportElement(element) {
    this._viewportElements.push(element);
  }

  /**
   * @returns {HTMLElement[]}
   */
  getViewportElements() {
    return this._viewportElements;
  }

  /**
   * @param {HTMLElement} element
   */
  set conversion(element) {
    this._conversion = element;
    this.addViewportElement(this._conversion);
  }

  /**
   * @param {HTMLElement} element
   */
  set footer(element) {
    this._footer = element;
    this.addViewportElement(this._footer);
  }

  /**
   * @returns {HTMLElement[]}
   */
  getVisibleViewportElements() {
    const bottom = (window.scrollY + window.innerHeight);
    const visibleViewportElements = [];

    this._viewportElements.forEach((element) => {
      const top = element.offsetTop;
      let margin = SCROLL_MARGIN;

      if (top <= SCROLL_MARGIN) {
        margin = 0;
      }

      if (top <= (bottom - margin)) {
        visibleViewportElements.push(element);
      }
    });

    return visibleViewportElements;
  }

  /**
   * @returns {boolean}
   */
  isAtFooter() {
    if (this._footer === null) {
      return false;
    }

    const bottom = (window.scrollY + window.innerHeight);
    const footerTop = this._footer.offsetTop;

    return (footerTop <= (bottom + SCROLL_MARGIN));
  }

  /**
   *
   */
  hideConversion() {
    if (this._conversion === null) {
      return;
    }

    if (!this._conversion.classList.contains(CLASS_IS_HIDDEN)) {
      this._conversion.classList.add(CLASS_IS_HIDDEN);
    }
  }

  /**
   *
   */
  showConversion() {
    if (this._conversion === null) {
      return;
    }

    if (this._conversion.classList.contains(CLASS_IS_HIDDEN)) {
      this._conversion.classList.remove(CLASS_IS_HIDDEN);
    }
  }
}